// src/screens/LetsPortfolio.jsx

import React, { useState } from 'react';
import { Image, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import portfolioImage from '../../../assets/img/portfolioImage.png';
import '../Portfolio.scss';
import { PortfolioServiceApi, Configuration } from "../../../services/portfolio";
import { APIControl } from '../../../helpers/APIControl';
import CreatePortfolioModal from './CreatePortfolioModal';

const LetsPortfolio = ({ onAddPortfolio }) => {
    const portfolioServiceApi = new PortfolioServiceApi(
        new Configuration({ basePath: process.env.REACT_APP_PORTFOLIO_API_BASE_PATH }),
        undefined,
        APIControl(process.env.REACT_APP_PORTFOLIO_API_BASE_PATH)
    );
    const token = useSelector((state) => state.auth?.token);

    const [showModal, setShowModal] = useState(false);

    const handleAddPortfolioClick = () => {
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
    };

    const createPortfolio = async (portfolioName) => {
        try {
            let requestBody = { name: portfolioName };
            const response = await portfolioServiceApi.v1PortfolioCreatePost(token, requestBody);
            if (response.data) {
                onAddPortfolio();
            } else {
                console.error(response);
            }
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className="letsPortfolioContainer">
            <div className="imageWrapper">
                <Image src={portfolioImage} className="portfolioImage" />
            </div>
            <div className="pageText">İlk portföyünüzü oluşturmaya başlayalım!</div>
            <Button className="addButton custom-button" onClick={handleAddPortfolioClick}>
                İşlem Ekle
            </Button>

            <CreatePortfolioModal
                show={showModal}
                onClose={handleClose}
                onPortfolioCreated={onAddPortfolio}
            />
        </div>
    );
};

export default LetsPortfolio;
